const cloneDateObject = (date) => {
    return new Date(date.valueOf())
} 

export default cloneDateObject